'use strict';

angular.module('adminSystemOwnerReviewRoutes', ['AdminSystemOwnerReviewControllers',
                                                'services.systemOwnerReview',
                                                'services.authenticatedUser'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('adminSystemOwnerReview', {
            url: '/Administration/SystemOwner/Review',
            templateUrl: require('./Administration.tpl.html'),
            controller: 'AdministrationController',
            resolve: {
                authenticatedUser: [
                    'authenticatedUserService', function (service) {
                        return service.getAuthenticatedUser();
                    }
                ],
                currentPeriod: ['systemOwnerReviewService', function (service) {
                    return service.getCurrentPeriod();
                }],
                systemOwnerReviewProcesses: ['adminSystemOwnerReviewService', function (service) {
                    return service.getAllSystemOwnerReviewProcesses();
                }],
                systemOwnersAndChanges : ['adminSystemOwnerReviewService', function (service) {
                    return service.getPrimarySystemOwnersAndChanges();
                }]                
            }
        });
}]);